module.exports = __webpack_public_path__ + "static/img/kefu.968e39e4.png";